import styled from "@emotion/styled";

import { sizeToken } from "../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import {
    reactUiModalLeftPadding,
    reactUiModalRightPadding,
} from "../../../Internals/ThemeProvider/ReactUiModalPaddings";

export const TemplateEditable = styled.div({
    padding: `${sizeToken(0.5)}px ${reactUiModalRightPadding}px ${sizeToken(0.5)}px ${reactUiModalLeftPadding - 11}px`,
});

export const TooltipContent = styled.div({
    width: 250,
});
